var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"py-4 text-center smaller--text black70--text"},[_c('p',{staticClass:"font-weight-medium mb-2"},[_vm._v(_vm._s(_vm.lang.footerPoweredBy))]),(_vm.merchant)?_c('span',[_vm._v(_vm._s(_vm.merchant.name)+" "+_vm._s(_vm.lang.footerMessage))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }